<script>
import {db} from "@/firebase/init";
import swal from "sweetalert2";

export default {
  data() {
    return {
      loading: false,
      hostname: '',
      vpsBackups: [],
      dateSort: null
    }
  },
  computed: {
    modifiedVpsBackups()
    {
      let array = this.vpsBackups
      if (this.dateSort === 'asc') {
        console.log('in type')
        array.sort(
            (a, b) => new Date(a.date) - new Date(b.date)
        );
      } else if (this.dateSort === 'desc') {
        array.sort(
            (a, b) => new Date(b.date) - new Date(a.date)
        );
      }
      return array
    }
  },
  mounted() {
    this.initDataTable('Please search by hostname to list backups.')
  },
  methods: {
    dateSortFunc() {
      if (!this.dateSort) {
        this.dateSort = 'desc'
      } else if (this.dateSort === 'desc') {
        this.dateSort = 'asc'
      } else {
        this.dateSort = null
      }
    },
    initDataTable (msg) {
      /* eslint-disable */
      $(document).ready(function () {
        $(".vps-datatable").DataTable({
          ordering: true,
          retrieve: true,
          'columnDefs': [ {
            'targets': [3], // column index (start from 0)
            'orderable': false, // set orderable false for selected columns
          }],
          language: {
            search: "_INPUT_",
            searchPlaceholder: "Search",
            emptyTable: msg,
            size: '40'
          }
        });
      });
      /* eslint-enable */
    },
    async getVpsBackup () {
      try {
        if(!this.hostname) {
          swal('Error', 'Please enter hostname first.', 'error')
          return
        }
        this.loading = true
        $(".vps-datatable").DataTable().destroy();
        let resp = await this.$http.post('/backup/fetch-vps-backups',{
          grant_type:'token',
          hostname: this.hostname
        });
        console.log('resp', resp)
        if(resp.data.success){
          const {result} = resp.data;
          const array = []
          for(const row of Object.keys(result)){
            for(const row1 of result[row]){
              array.push({...row1, date: (row1.date), backupServer: row})
            }
          }
          console.log('array', array)
          this.vpsBackups = array
        }

      } catch (e) {
        console.log('error while fetching vps backups', e.toString())
      } finally {
        this.loading = false;
        this.hostname = ''
        this.initDataTable("No backup exists");
      }
    },
  }
}
</script>

<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title pull-left">
              VPS Backups
            </h4>
          </div>
          <div class="card-body">
            <div class="row mb-20">
              <div class="col-md-3">
                <label for=""><b>Hostname</b></label>
                <input @keydown.enter="getVpsBackup"  v-model="hostname" placeholder="Search by hostname" type="text" class="form-control">
              </div>
              <div class="col-md-2 d-flex align-items-end">
                <button @click="getVpsBackup()" class="btn btn-primary mb-0">Search</button>
                <div class="loader small_loader ml-20" v-if="loading"></div>
              </div>
            </div>
            <table class="table table-striped table-bordered vps-datatable">
              <thead>
              <tr>
                <th class="text-center">Path</th>
                <th class="text-center">Backup server</th>
                <th class="text-center">Size</th>
                <th class="text-center">Date (CST)
                  <i v-if="!dateSort || dateSort==='desc'" class="fa fa-sort-down make-cursor-pointer" :class="dateSort==='desc' ? 'text-primary': 'text-muted'" @click="dateSortFunc()" />
                  <i v-if="!dateSort || dateSort==='asc'"  class="fa fa-sort-up make-cursor-pointer" :style="!dateSort?'margin-left:-8px':'' "  :class="dateSort==='asc' ? 'text-primary': 'text-muted'" @click="dateSortFunc()" /></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(row, index) in modifiedVpsBackups" :key="index">
                <td width="40%">{{row.path}}</td>
                <td class="text-center">{{row.backupServer}}</td>
                <td class="text-center">{{row.size}}</td>
                <td class="text-center">{{row.date}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>